import { RestClient } from '@/api/rest-client'
import { CustomerPortalLink } from '@/api/model/customer-portal-link'

export class CustomerPortalLinkClient extends RestClient<CustomerPortalLink> {
    collectionName = 'customer_portal_links'
    parseData = CustomerPortalLink.fromData
}
